import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
export function isEmpty(obj) {
  return !obj || Object.keys(obj).length === 0;
}
/**
 * Collapses (or “folds”) one or more data fields into two
 * properties: `key` (contains the original data field name)
 * and `value` (contains the original data value.)
 */
export var Fold = function Fold(options) {
  var fields = options.fields,
    _options$key = options.key,
    key = _options$key === void 0 ? 'key' : _options$key,
    _options$value = options.value,
    value = _options$value === void 0 ? 'value' : _options$value;
  return function (data) {
    if (isEmpty(fields)) return data;
    return data.flatMap(function (d) {
      return fields.map(function (f) {
        return Object.assign(Object.assign({}, d), _defineProperty(_defineProperty({}, key, f), value, d[f]));
      });
    });
  };
};
Fold.props = {};